import * as Sentry from '@sentry/nuxt'

const { sentryDsn, environment } = useRuntimeConfig().public

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment,
    debug: false,
    enableLogs: false,
    sendDefaultPii: false,
    sampleRate: 0.4,
    tracesSampleRate: 0,
  })
}
